import Planegl from '../../module/libs/planegl'

export default class fryingpanTechnology {
  constructor(param, scroll, isTop) {
    this.param = param;
    this.scroll = scroll;

    this.isIe = this.param.browserType === 'IE'
    this.isVideo = this.param.displayType === 'pc' && isTop

    this.isShowed = false
    this.isSpGraphShowed = false
    this.isPlay = false
  }

  init() {
    this.el = document.querySelector('.js__fryingpan-technology')

    if (this.isVideo) {
      this.elText = this.el.querySelector('.js__fryingpan-technology-text')
      this.elFryingpanAfter = this.el.querySelector('.js__fryingpan-technology-after')
    }

    this.elTechnologySpeed = this.el.querySelector('.c-technology__speed')
    this.elTechnologySpeedTitle = this.el.querySelector('.c-technology__speed__title')

    this.graph = []
    {
      const elGraph = this.el.querySelector('.c-technology__speed__graph__group.is-stainless')
      this.graph.push({
        count: 0,
        elGraph: elGraph,
        elNum: elGraph.querySelector('.num'),
        elBar: elGraph.querySelector('.c-technology__speed__graph__bar'),
        width: this.param.displayType === 'pc' ? 314 : 184,
      })
    }
    {
      const elGraph = this.el.querySelector('.c-technology__speed__graph__group.is-aluminum')
      this.graph.push({
        count: 0,
        elGraph: elGraph,
        elNum: elGraph.querySelector('.num'),
        elBar: elGraph.querySelector('.c-technology__speed__graph__bar'),
        width: this.param.displayType === 'pc' ? 292 : 169,
      })
    }
    {
      const elGraph = this.el.querySelector('.c-technology__speed__graph__group.is-no-coating')
      this.graph.push({
        count: 0,
        elGraph: elGraph,
        elNum: elGraph.querySelector('.num'),
        elBar: elGraph.querySelector('.c-technology__speed__graph__bar'),
        width: this.param.displayType === 'pc' ? 154 : 81,
      })
    }
    {
      const elGraph = this.el.querySelector('.c-technology__speed__graph__group.is-vermicular')
      this.graph.push({
        count: 0,
        elGraph: elGraph,
        elNum: elGraph.querySelector('.num'),
        elBar: elGraph.querySelector('.c-technology__speed__graph__bar'),
        width: this.param.displayType === 'pc' ? 192 : 106,
        start: 99,
      })
    }

    this.elTechnologySpeedGraphAttention = this.el.querySelector('.c-technology__speed__graph__attention')
    this.elTechnologySpeedGraphAttentionText = this.elTechnologySpeedGraphAttention.querySelector('.c-technology__speed__graph__attention__text')
    this.elTechnologySpeedGraphAttentionCircle = this.elTechnologySpeedGraphAttention.querySelectorAll('.c-technology__speed__graph__attention__circle')
    this.elTechnologySpeedGraphAttentionLine1 = this.elTechnologySpeedGraphAttention.querySelector('.c-technology__speed__graph__attention__arrow.is-1 .c-technology__speed__graph__attention__line')
    this.elTechnologySpeedGraphAttentionLine2 = this.elTechnologySpeedGraphAttention.querySelector('.c-technology__speed__graph__attention__arrow.is-2 .c-technology__speed__graph__attention__line')

    this.elTechnologySpeedReadmore = this.el.querySelector('.c-technology__speed__readmore')
    this.elTechnologySpeedGraphLine = this.el.querySelector('.c-technology__speed__graph__line')
    this.elTechnologySpeedBackground = this.el.querySelector('.c-technology__speed__background')

    this.elHeader = document.getElementById('l-header')

    if (this.isVideo) {
      TweenMax.set(this.elText, {
        opacity: 0,
      })
      if (!this.isIe) {
        TweenMax.set(this.elText, {
          willChange: 'opacity',
        })
      }

      TweenMax.set(this.elFryingpanAfter, {
        opacity: 0,
      })
      if (!this.isIe) {
        TweenMax.set(this.elFryingpanAfter, {
          willChange: 'opacity',
        })
      }
    }

    TweenMax.set(this.elTechnologySpeedTitle, {
      opacity: 0,
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedTitle, {
        willChange: 'opacity',
      })
    }

    for (let i = 0; i < this.graph.length; i++) {
      const { elGraph, elNum, elBar, start } = this.graph[i]
      TweenMax.set(elGraph, {
        opacity: 0,
      })
      if (!this.isIe) {
        TweenMax.set(elGraph, {
          willChange: 'opacity',
        })
      }
      TweenMax.set(elBar, {
        width: start || (this.param.displayType === 'pc' ? 66 : 24),
      })
      if (!this.isIe) {
        TweenMax.set(elBar, {
          willChange: 'width',
        })
      }
      this.graph[i].countMax = Number(elNum.innerText)
      elNum.innerText = 0
    }

    TweenMax.set(this.elTechnologySpeedGraphAttentionText, {
      opacity: 0,
      x: '+=10',
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedGraphAttentionText, {
        willChange: 'opacity, transform',
      })
    }
    TweenMax.set(this.elTechnologySpeedGraphAttentionCircle, {
      opacity: 0,
      scale: 0,
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedGraphAttentionCircle, {
        willChange: 'opacity, transform',
      })
    }
    TweenMax.set(this.elTechnologySpeedGraphAttentionLine1, {
      opacity: 0,
      width: 0,
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedGraphAttentionLine1, {
        willChange: 'opacity, width',
      })
    }
    TweenMax.set(this.elTechnologySpeedGraphAttentionLine2, {
      opacity: 0,
      height: 0,
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedGraphAttentionLine2, {
        willChange: 'opacity, height',
      })
    }

    if (this.isVideo) {
      TweenMax.set(this.elTechnologySpeedReadmore, {
        opacity: 0,
      })
      if (!this.isIe) {
        TweenMax.set(this.elTechnologySpeedReadmore, {
          willChange: 'opacity',
        })
      }
    }
    TweenMax.set(this.elTechnologySpeedGraphLine, {
      opacity: 0,
      bottom: '100%',
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedGraphLine, {
        willChange: 'opacity, bottom',
      })
    }
    TweenMax.set(this.elTechnologySpeedBackground, {
      opacity: 0,
      top: '100%',
    })
    if (!this.isIe) {
      TweenMax.set(this.elTechnologySpeedBackground, {
        willChange: 'opacity, top',
      })
    }

    if(this.param.displayType === 'sp') {
      TweenMax.set('.c-technology__text__main', { opacity: 0, y: 12 })
      TweenMax.set('.c-technology__text__en', { opacity: 0, y: 12 })
      TweenMax.set('.c-technology__text__kana', { opacity: 0, y: 12 })
    }
    
    if (this.isVideo) {
      this.loadVideo()
    } else {
      this.isLoadedVideo = true
      this.start()
    }

    setTimeout(() => {
      this.setSize()
    }, 16)
  }

  loadVideo() {
    this.video = document.createElement('video')
    this.video.addEventListener('loadedmetadata', () => {
      this.isLoadedVideo = true
      this.video.play()
      this.video.pause()
      this.initGl()
      this.start()
    })
    this.video.muted = true
    this.video.src = '/assets/img/products/fryingpan/top/b-technology_watervapor.mp4'
  }

  initGl() {
    this.kglWatervapor = new Planegl({
      canvas: '#technology-fryingpan-watervapor',
      fragmentShader: `
        precision highp float;

        uniform vec2 resolution;
        uniform sampler2D video;

        vec2 adjustRatio(vec2 coord, vec2 inputResolution, vec2 outputResolution) {
          vec2 ratio = vec2(
            min((outputResolution.x / outputResolution.y) / (inputResolution.x / inputResolution.y), 1.0),
            min((outputResolution.y / outputResolution.x) / (inputResolution.y / inputResolution.x), 1.0)
          );
          return coord * ratio + (1. - ratio) * 0.5;
        }

        void main() {
          vec2 uv = gl_FragCoord.xy / resolution;
          uv = adjustRatio(uv, vec2(1440., 810.), resolution);
          vec4 colorVideo = texture2D(video, uv);
          gl_FragColor = vec4(colorVideo.rgb, (colorVideo.r + colorVideo.g + colorVideo.b) / 3.);
        }
      `,
      uniforms: {
        video: {
          type: 'image',
          value: this.video,
        },
      },
      tick: (kgl) => {
        kgl.updateTexture('video', this.video)
      },
      hasTime: false,
      isAutoStart: false,
    })
  }

  start() {
    if (!this.isLoadedVideo || !this.isShowed) return

    if (this.isVideo) {
      this.video.play()
      this.isPlay = true
      this.animateFryingpan()
    } else {
      this.animateSpTexts()
    }
  }

  animateFryingpan() {
    const tl = this.tl = this.tl || new TimelineMax({
      onComplete: () => {
        this.isPlay = false
      }
    })

    // テキストフェードイン
    if (this.isVideo) {
      tl.addLabel('fadeIn', 0.5)

      tl.to(this.elText, 3, {
        opacity: 1,
      }, 'fadeIn')

      // 蒸発後フライパン
      tl.to(this.elFryingpanAfter, 2, {
        opacity: 1,
      }, 'fadeIn')

      // テキストフェードアウト
      tl.to(this.elText, 0.55, {
        opacity: 0,
        ease: Power2.easeOut,
      }, 'fadeIn+=3')
    }

    this.animateSpeed()
  }

  animateSpTexts() {
    TweenMax.to('.c-technology__text__main', 1.0, { opacity: 1, ease: Power3.easeOut })
    TweenMax.to('.c-technology__text__en', 0.7, { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.4 })
    TweenMax.to('.c-technology__text__kana', 0.7, { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.6 })
  }

  animateSpeed() {
    const tl = this.tl = this.tl || new TimelineMax({
      onComplete: () => {
        this.isPlay = false
      }
    })

    // 蒸発スピードグラフ表示
    tl.addLabel('speed', '-=0.1')

    tl.to(this.elTechnologySpeedBackground, 0.4, {
      top: 0,
      ease: Power2.easeOut,
    }, 'speed')
    tl.to(this.elTechnologySpeedBackground, 0.4, {
      opacity: 1,
      ease: Power1.easeOut,
    }, 'speed')

    // 見出し
    tl.to(this.elTechnologySpeedTitle, 0.2, {
      opacity: 1,
      ease: Power2.easeOut,
    }, 'speed+=0.2')

    // グラフ
    tl.addLabel('speedGraph', '-=0.1')

    // 軸
    tl.to(this.elTechnologySpeedGraphLine, 0.5, {
      opacity: 1,
      bottom: 0,
      ease: Power2.easeOut,
    }, 'speedGraph')

    // 通常フライパン
    let i = 0
    for (i = 0; i < this.graph.length - 1; i++) {
      const obj = this.graph[i]
      const { elGraph, elNum, elBar, width, countMax } = obj
      const delay = 0.35 * i
      tl.to(elGraph, 0.5, {
        opacity: 1,
        ease: Power2.easeOut,
        delay,
      }, 'speedGraph')
      tl.to(elBar, 1, {
        width,
        ease: Power1.easeOut,
        delay,
      }, 'speedGraph')
      tl.to(obj, 1, {
        count: countMax,
        ease: Power1.easeOut,
        delay,
        onUpdate: () => {
          elNum.innerText = Math.floor(obj.count)
        }
      }, 'speedGraph')
    }

    // バーミキュラフライパン
    {
      const obj = this.graph[i]
      const { elGraph, elNum, elBar, width, countMax } = obj
      const delay = 0.35 * i
      tl.to(elGraph, 0.25, {
        opacity: 1,
        ease: Power2.easeOut,
        delay,
      }, 'speedGraph')
      tl.to(elBar, 0.7, {
        width,
        ease: Power1.easeOut,
        delay,
      }, 'speedGraph')
      tl.to(obj, 0.7, {
        count: countMax,
        ease: Power1.easeOut,
        delay,
        onUpdate: () => {
          elNum.innerText = Math.floor(obj.count)
        }
      }, 'speedGraph')
    }

    // 100倍早く文言
    tl.addLabel('attention', `speedGraph+=${0.35 * this.graph.length}`)

    tl.to(this.elTechnologySpeedGraphAttentionText, 1, {
      opacity: 1,
      x: 0,
      ease: Power2.easeOut,
    }, 'attention')

    tl.addLabel('attentionLine', 'attention+=0.2')

    tl.to(this.elTechnologySpeedGraphAttentionCircle, 1, {
      opacity: 1,
      scale: 1,
      ease: Power2.easeOut,
    }, 'attentionLine')
    tl.to(this.elTechnologySpeedGraphAttentionLine1, 1, {
      opacity: 1,
      width: this.param.displayType === 'pc' ? 25 : window.innerWidth * 0.048,
      ease: Power2.easeOut,
    }, 'attentionLine')
    tl.to(this.elTechnologySpeedGraphAttentionLine2, 1, {
      opacity: 1,
      height: this.param.displayType === 'pc' ? 50 : window.innerWidth * 0.0773,
      ease: Power2.easeOut,
    }, 'attentionLine')

    // read more
    if (this.isVideo) {
      tl.to(this.elTechnologySpeedReadmore, 1, {
        opacity: 1,
        ease: Power2.easeOut,
      }, 'attention')
    }
  }

  onScroll(_y) {
    if (!this.isShowed && _y > this.topStart) {
      this.isShowed = true
      // アニメーション開始
      this.start()
    }

    if(!this.isSpGraphShowed && _y > this.graphStart) {
      this.isSpGraphShowed = true
      this.animateSpeed()
    }
  }

  setSize(_w, _h = window.innerHeight, _display) {
    if(this.isVideo) {
      this.topEl = this.elTechnologySpeed.getBoundingClientRect().top + window.pageYOffset - this.elHeader.offsetHeight
      this.topStart = this.topEl - _h * 0.3
    } else {
      this.topEl = this.el.getBoundingClientRect().top + window.pageYOffset - this.elHeader.offsetHeight
      this.topStart = this.topEl - _h * (this.param.displayType === 'pc' ? 0.3 : 0.4)
      this.topSpeed = this.elTechnologySpeedTitle.getBoundingClientRect().top + window.pageYOffset - this.elHeader.offsetHeight
      this.graphStart = this.topSpeed - _h * (this.param.displayType === 'pc' ? 0.6 : 0.7)
    }
  }

  render(_y, _h) {
    if (!this.isPlay) return
    this.kglWatervapor.render()
  }

  resize(_w, _h, _display) {
    this.setSize(_w, _h, _display)
  }
}
